//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('oeeStateRemarks', {
//        templateUrl: 'views/components/views/oeeStateRemarks/oeeStateRemarks.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'selectOeeStateRemarkService', function ($stateParams, stateService, selectOeeStateRemarkService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let oeeStateKeyno = $stateParams.oeestate_keyno;

//            vm.model = {
//                itemsListRemarks: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region PROCEDURE FUNCTION CALL

//            async function loadRemarks() {
//                vm.model.itemsListRemarks = await selectOeeStateRemarkService.listRemarks({ oeestate_keyno: oeeStateKeyno });
//            }

//            // #endregion PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'oeestateremark':
//                        go({
//                            oeestate_keyno: oeeStateKeyno,
//                            oeestateremark_keyno: '0'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadRemarks();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
